import React, { useState } from 'react'
import { Box } from '@mui/joy';

import { useTranslation } from 'react-i18next';
import { Tag } from 'src/mtska-frontend-app-component';

const DriverHelpIt = () => {
    const { t } = useTranslation();
    const [selectedRenter, setSelectedRenter] = useState();
    const getSubdomain = () => {
        const host = window.location.hostname.split('.');
        return host.length > 2 ? host[0] : '';
    };
    const customerSupportEmail = "driver" + getSubdomain() + "@myfleetsolution.it"


    return (
        <Box className={"dashboard dashboard-driver-help" + (selectedRenter ? ' filtered ' + selectedRenter : '')}>
            <Tag>{t('Help')}</Tag>
            <h1 style={{ color: 'var(--app-main)' }}>{t('Guida pratica ai servizi di mobilità')}</h1>
            <p class="smielato">
                Caro Driver,<br /><br />
                sappiamo quanto sia importante per te gestire ogni tua necessità di mobilità in modo semplice e diretto.  Allo scopo ti abbiamo preparato una guida pratica che ti indichi chi contattare per ogni esigenza.<br />
                Ti consigliamo di stamparne una copia e di tenerla in auto.<br /><br />
                Grazie
            </p>
            <h4>Seleziona il noleggiatore per filtrare le informazioni:</h4>
            <div className="renterSelecterWrapper">
                <ul className="renterSelecter">

                    <li><Tag color={selectedRenter == 'alphabet' ? "success" : ""} size="medium" onClick={() => setSelectedRenter('alphabet')}>Alphabet</Tag></li>
                    <li><Tag color={selectedRenter == 'ald' ? "success" : ""} size="medium" onClick={() => setSelectedRenter('ald')}>ALD</Tag></li>
                    <li><Tag color={selectedRenter == 'arval' ? "success" : ""} size="medium" onClick={() => setSelectedRenter('arval')}>Arval</Tag></li>
                    <li><Tag color={selectedRenter == 'athlon' ? "success" : ""} size="medium" onClick={() => setSelectedRenter('athlon')}>Athlon</Tag></li>
                    <li><Tag color={selectedRenter == 'ayvens' ? "success" : ""} size="medium" onClick={() => setSelectedRenter('ayvens')}>Ayvens</Tag></li>
                    <li><Tag color={selectedRenter == 'leaseplan' ? "success" : ""} size="medium" onClick={() => setSelectedRenter('leaseplan')}>LeasePlan</Tag></li>
                    <li><Tag color={selectedRenter == 'leasys' ? "success" : ""} size="medium" onClick={() => setSelectedRenter('leasys')}>Leasys</Tag></li>
                    <li><Tag color={selectedRenter == 'rent365' ? "success" : ""} size="medium" onClick={() => setSelectedRenter('rent365')}>Rent365</Tag></li>
                    <li><Tag color={selectedRenter == 'unipol' ? "success" : ""} size="medium" onClick={() => setSelectedRenter('unipol')}>UnipolRental</Tag></li>
                    <li><Tag color={selectedRenter == 'vwleasing' ? "success" : ""} size="medium" onClick={() => setSelectedRenter('vwleasing')}>Volkswagen Leasing</Tag></li>

                </ul>
            </div>
            <div class="assistance-container">
                <div class="assistance-item">
                    <h2>Esigenze Urgenti</h2>
                </div>

                <div class="assistance-item">
                    <h3>SOCCORSO STRADALE ITALIA</h3>
                    <div class="assistance-details">
                        <div class="brand arval">
                            <strong>Arval:</strong> 800 16 55 00 - Se Mid Term Contattare il numero 800 894506
                        </div>
                        <div class="brand leaseplan">
                            <strong>Leaseplan:</strong> 800 146 146 - Se Flexi Plan Contattare il numero 800.146.146
                        </div>
                        <div class="brand vwleasing">
                            <strong>Volkswagen Leasing:</strong> Contattare il numero 800.44.99.88
                        </div>

                        <div class="brand alphabet">
                            <strong>Alphabet:</strong> Contattare il numero 800-591591
                        </div>
                        <div class="brand athlon">
                            <strong>Athlon:</strong> Contattare il numero 800.010.529
                        </div>
                        <div class="brand ald">
                            <strong>ALD:</strong> Contattare il numero 800 826 001
                        </div>
                        <div class="brand ayvens">
                            <strong>Ayvens:</strong> Contattare il numero 800 426 426
                        </div>
                        <div class="brand leasys">
                            <strong>Leasys:</strong> Contattare il numero 800 33 44 22
                        </div>
                        <div class="brand rent365">
                            <strong>Rent365:</strong> Contattare il numero 02 47754690
                        </div>
                        <div class="brand unipol">
                            <strong>Unipol Rental:</strong> Contattare il numero 800.936.603
                        </div>


                    </div>
                </div>

                <div class="assistance-item">
                    <h3>SOCCORSO STRADALE ESTERO</h3>
                    <div class="assistance-details">
                        <div class="brand arval">
                            <strong>Arval:</strong> +39 055 5329600 - Se Mid Term Contattare il numero 800 894506
                        </div>
                        <div class="brand leaseplan">
                            <strong>Leaseplan:</strong> 02 66165560 - Se Flexi Plan Contattare il numero 800.146.146
                        </div>
                        <div class="brand vwleasing">
                            <strong>Volkswagen Leasing:</strong> Contattare il numero +39 02.66.16.53.02
                        </div>


                        <div class="brand alphabet">
                            <strong>Alphabet:</strong> Contattare il numero +39 02 51 61 05 99
                        </div>
                        <div class="brand athlon">
                            <strong>Athlon:</strong> Contattare il numero 0039 02.582.862.66
                        </div>
                        <div class="brand ald">
                            <strong>ALD:</strong> Contattare il numero +39 02 66165605
                        </div>
                        <div class="brand ayvens">
                            <strong>Ayvens:</strong> Contattare il numero + 39 02 661 65 605
                        </div>
                        <div class="brand leasys">
                            <strong>Leasys:</strong> Contattare il numero 0039 02 44412785
                        </div>
                        <div class="brand rent365">
                            <strong>Rent365:</strong> Contattare il numero 02 47754690
                        </div>
                        <div class="brand unipol">
                            <strong>Unipol Rental:</strong> Contattare il numero 390.522.040.782
                        </div>
                    </div>
                </div>

                <div class="assistance-item">
                    <h3>PRENOTARE VETTURA SOSTITUTIVA</h3>
                    <div class="assistance-details">
                        <div class="brand arval">
                            <strong>Arval:</strong> Presso il Service Point dell'intervento oppure in autonomia al numero 800 16 55 00 - Se Mid Term Contattare il numero 800 894506
                        </div>
                        <div class="brand leaseplan">
                            <strong>Leaseplan:</strong> Presso il Service Point dell'intervento oppure in autonomia al numero 800 146 146
                        </div>
                        <div class="brand vwleasing">
                            <strong>Volkswagen Leasing:</strong> Richiederla direttamente al Service Point che effettuerà il ripristino vettura oppure in autonomia al numero 800.44.99.88
                        </div>

                        <div class="brand alphabet">
                            <strong>Alphabet:</strong> Contattare il numero 800-591591
                        </div>
                        <div class="brand athlon">
                            <strong>Athlon:</strong> Contattare il numero 800.531.929.
                        </div>
                        <div class="brand ald">
                            <strong>ALD:</strong> Presso il Service Point dell'intervento oppure in autonomia al numero 800 426 426
                        </div>
                        <div class="brand ayvens">
                            <strong>Ayvens:</strong> Presso il Service Point dell'intervento oppure in autonomia al numero 800 426 426
                        </div>
                        <div class="brand leasys">
                            <strong>Leasys:</strong> Contattare il numero 800 33 44 22
                        </div>
                        <div class="brand rent365">
                            <strong>Rent365:</strong> Richiederla direttamente al Service Point che effettuerà il ripristino vettura oppure contattare 02 47754690
                        </div>
                        <div class="brand unipol">
                            <strong>Unipol Rental:</strong> Contattare il numero 800.936.603
                        </div>
                    </div>
                </div>
            </div>

            <div class="assistance-container">
                <div class="assistance-item">
                    <h2>Incidente, furto, atto vandalico, danno kasco, certificato di assicurazione</h2>
                </div>

                <div class="assistance-item">
                    <h3>DENUNCIA DI UN SINISTRO</h3>
                    <div class="assistance-details">
                        <div class="brand arval">
                            <strong>Arval:</strong> scrivere a <a href="mailto:sinistri@arval.it">sinistri@arval.it</a> con in cc <a href={"mailto:" + customerSupportEmail}>{customerSupportEmail}</a>
                        </div>
                        <div class="brand leaseplan">
                            <strong>Leaseplan:</strong> Compilare il form online sul <a href="https://www.ayvens.com/it-it/assistenza-clienti/denuncia-sinistri/">portale del Noleggiatore</a> e inoltrare e-mail a: <a href={"mailto:" + customerSupportEmail}>{customerSupportEmail}</a>
                        </div>
                        <div class="brand vwleasing">
                            <strong>Volkswagen Leasing:</strong> Compilare il form online sul <a href="https://www.vwfs.it/denuncia-sinistri.html">portale del Noleggiatore</a> c/c <a href={"mailto:" + customerSupportEmail}>{customerSupportEmail}</a>
                        </div>

                        <div class="brand alphabet">
                            <strong>Alphabet:</strong> Scrivere a sinistri@alphabet.com con copia dei moduli di denuncia
                        </div>
                        <div class="brand athlon">
                            <strong>Athlon:</strong> Compilare il form online <a href="https://athlonweb.sdmain.com/driver/">sul sito</a>
                        </div>
                        <div class="brand ald">
                            <strong>ALD:</strong> Compilare il form online <a href="https://nemo.aldautomotive.it/static/claims_public.html">sul sito</a>
                        </div>
                        <div class="brand ayvens">
                            <strong>Ayvens:</strong> Compilare il form online <a href="https://www.ayvens.com/it-it/assistenza-clienti/denuncia-sinistri/">sul sito</a>
                        </div>
                        <div class="brand leasys">
                            <strong>Leasys:</strong> Compilare il form online <a href="https://www.leasys.com/it/italiano/denuncia-sinistri">sul sito</a>
                        </div>
                        <div class="brand rent365">
                            <strong>Rent365:</strong> scrivere a <a href={"mailto:" + customerSupportEmail}>{customerSupportEmail}</a>
                        </div>
                        <div class="brand unipol">
                            <strong>Unipol Rental:</strong> Contattare il numero 800.936.603
                        </div>
                    </div>
                </div>

                <div class="assistance-item">
                    <h3>CERTIFICATO DI ASSICURAZIONE</h3>
                    <div class="assistance-details">
                        <div class="brand arval">
                            <strong>Arval:</strong> scrivere a <a href={"mailto:" + customerSupportEmail}>{customerSupportEmail}</a> oppure contattare il numero <a href="tel:800165500">800.16.55.00</a>
                        </div>
                        <div class="brand leaseplan">
                            <strong>Leaseplan:</strong> scrivere a <a href={"mailto:" + customerSupportEmail}>{customerSupportEmail}</a> oppure contattare il numero <a href="tel:800146146">800.146.146</a>
                        </div>
                        <div class="brand vwleasing">
                            <strong>Volkswagen Leasing:</strong> scrivere a <a href={"mailto:" + customerSupportEmail}>{customerSupportEmail}</a> oppure contattare il numero <a href="tel:0233027582">02 33027582</a>
                        </div>


                        <div class="brand alphabet">
                            <strong>Alphabet:</strong> scrivere a <a href={"mailto:" + customerSupportEmail}>{customerSupportEmail}</a>
                        </div>
                        <div class="brand athlon">
                            <strong>Athlon:</strong> scrivere a <a href={"mailto:" + customerSupportEmail}>{customerSupportEmail}</a>
                        </div>
                        <div class="brand ald">
                            <strong>ALD:</strong> scrivere a <a href={"mailto:" + customerSupportEmail}>{customerSupportEmail}</a>
                        </div>
                        <div class="brand ayvens">
                            <strong>Ayvens:</strong> scrivere a <a href={"mailto:" + customerSupportEmail}>{customerSupportEmail}</a>
                        </div>
                        <div class="brand leasys">
                            <strong>Leasys:</strong> scrivere a <a href={"mailto:" + customerSupportEmail}>{customerSupportEmail}</a>
                        </div>
                        <div class="brand rent365">
                            <strong>Rent365:</strong> scrivere a <a href={"mailto:" + customerSupportEmail}>{customerSupportEmail}</a>
                        </div>
                        <div class="brand unipol">
                            <strong>Unipol Rental:</strong> scrivere a <a href={"mailto:" + customerSupportEmail}>{customerSupportEmail}</a>
                        </div>
                    </div>
                </div>
            </div>

            <div class="assistance-container">
                <div class="assistance-item">
                    <h2>Gestione quotidiana</h2>
                </div>

                <div class="assistance-item">
                    <h3>REPERIRE UN'OFFICINA, CARROZZERIA, CENTRO REVISIONI O GOMMISTA</h3>
                    <div class="assistance-details">
                        <div class="brand arval">
                            <strong>Arval:</strong> <a href="tel:800165500">800 16 55 00</a> oppure tramite APP "MYARVAL" - Se Mid Term contattare il numero <a href="tel:800894506">800 894506</a>
                        </div>
                        <div class="brand leaseplan">
                            <strong>Leaseplan:</strong> Contattare il numero <a href="tel:800146146">800.146.146</a>
                        </div>
                        <div class="brand vwleasing">
                            <strong>Volkswagen Leasing:</strong> Fare riferimento alla rete ufficiale di concessionarie e Service Partner del Gruppo Volkswagen. Contattare il numero <a href="tel:0233027582">02 33027582</a>
                        </div>

                        <div class="brand alphabet">
                            <strong>Alphabet:</strong> 800-591591 o tramite app https://www.alphabet.com/it-it/alphabet-mobility-services-app
                        </div>
                        <div class="brand athlon">
                            <strong>Athlon:</strong> Contattare il numero 800.531.929
                        </div>
                        <div class="brand ald">
                            <strong>ALD:</strong> 800 426 426 oppure https://ald.mobilitysolutions.it/rete-assistenza/#
                        </div>
                        <div class="brand ayvens">
                            <strong>Ayvens:</strong> 800 426 426
                        </div>
                        <div class="brand leasys">
                            <strong>Leasys:</strong> 800 33 44 22
                        </div>
                        <div class="brand rent365">
                            <strong>Rent365:</strong> 02 47754690 oppure 329 6385158
                        </div>
                        <div class="brand unipol">
                            <strong>Unipol Rental:</strong> 800.936.603
                        </div>
                    </div>
                </div>

                <div class="assistance-item">
                    <h3>PRENOTARE UN TAGLIANDO, UN CAMBIO GOMME O UN INTERVENTO DI MANUTENZIONE</h3>
                    <div class="assistance-details">
                        <div class="brand arval">
                            <strong>Arval:</strong> <a href="tel:800165500">800 16 55 00</a> oppure tramite APP "MYARVAL" - Se Mid Term contattare il numero <a href="tel:800894506">800 894506</a>
                        </div>
                        <div class="brand leaseplan">
                            <strong>Leaseplan:</strong> Contattare il numero <a href="tel:800146146">800.146.146</a> oppure il Driver Contact Center al <a href="tel:0800845650">0800 845 650</a>, internazionale <a href="tel:+41447466333">+41 44 746 6333</a>
                        </div>
                        <div class="brand vwleasing">
                            <strong>Volkswagen Leasing:</strong> Fare riferimento alla rete ufficiale di concessionarie e Service Partner del Gruppo Volkswagen. Contattare il numero <a href="tel:0233027582">02 33027582</a>
                        </div>

                        <div class="brand alphabet">
                            <strong>Alphabet:</strong> 800-591591 o tramite app https://www.alphabet.com/it-it/alphabet-mobility-services-app
                        </div>
                        <div class="brand athlon">
                            <strong>Athlon:</strong> Contattare il numero 800.531.929
                        </div>
                        <div class="brand ald">
                            <strong>ALD:</strong> Contattare il numero 800 426 426 oppure Consultare il portale del Noleggiatore https://ald.mobilitysolutions.it/rete-assistenza/#
                        </div>
                        <div class="brand ayvens">
                            <strong>Ayvens:</strong> 800 426 426
                        </div>
                        <div class="brand leasys">
                            <strong>Leasys:</strong> 800 33 44 22
                        </div>
                        <div class="brand rent365">
                            <strong>Rent365:</strong> 02 47754690 oppure 329 6385158
                        </div>
                        <div class="brand unipol">
                            <strong>Unipol Rental:</strong> 800.936.603
                        </div>
                    </div>
                </div>

                <div class="assistance-item">
                    <h3>RICHIESTA DI INFORMAZIONI/RISOLUZIONE DI PROBLEMATICHE VARIE</h3>
                    <div class="assistance-details">
                        <div class="brand arval">
                            <strong>Arval:</strong> Scrivere a <a href={"mailto:" + customerSupportEmail}>{customerSupportEmail}</a>
                        </div>
                        <div class="brand leaseplan">
                            <strong>Leaseplan:</strong> Scrivere a <a href={"mailto:" + customerSupportEmail}>{customerSupportEmail}</a>
                        </div>
                        <div class="brand vwleasing">
                            <strong>Volkswagen Leasing:</strong> Scrivere a <a href={"mailto:" + customerSupportEmail}>{customerSupportEmail}</a>
                        </div>

                        <div class="brand alphabet">
                            <strong>Alphabet:</strong> scrivere a <a href={"mailto:" + customerSupportEmail}>{customerSupportEmail}</a>
                        </div>
                        <div class="brand athlon">
                            <strong>Athlon:</strong> scrivere a <a href={"mailto:" + customerSupportEmail}>{customerSupportEmail}</a>
                        </div>
                        <div class="brand ald">
                            <strong>ALD:</strong> scrivere a <a href={"mailto:" + customerSupportEmail}>{customerSupportEmail}</a>
                        </div>
                        <div class="brand ayvens">
                            <strong>Ayvens:</strong> scrivere a <a href={"mailto:" + customerSupportEmail}>{customerSupportEmail}</a>
                        </div>
                        <div class="brand leasys">
                            <strong>Leasys:</strong> scrivere a <a href={"mailto:" + customerSupportEmail}>{customerSupportEmail}</a>
                        </div>
                        <div class="brand rent365">
                            <strong>Rent365:</strong> scrivere a <a href={"mailto:" + customerSupportEmail}>{customerSupportEmail}</a>
                        </div>
                        <div class="brand unipol">
                            <strong>Unipol Rental:</strong> scrivere a <a href={"mailto:" + customerSupportEmail}>{customerSupportEmail}</a>
                        </div>
                    </div>
                </div>
            </div>

        </Box>
    )

}

export default DriverHelpIt;


